// extracted by css-extract-rspack-plugin
export default {"container":"FreeChatExceededBanner-module__container__DWo9J"};